import React, { useState } from "react";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import theme from "./components/themes/default";
import MealSelector from "./components/pages/MealSelector";
import CustomerPortal from "./components/pages/CustomerPortal";
import NotFound from "./components/pages/NotFound";
import MenuPage from "./components/pages/Menu";

const queryString = require("query-string");

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    box-sizing: border-box;
  }

  .meal-constructor {
      margin-bottom: 60px;
  }

  .meal-constructor,
  .meal-constructor * {
    box-sizing: border-box;
  }
`;

export default function App() {
  const parsed = queryString.parse(window.location.search);
  const [customerId, setCustomerId] = useState(window.theme.customerId);
  const templatePage = window.theme.templatePage;
   const mealConstructorCollections = window.mealConstructorCollections; //Shopify collection Ids
  const mealSettings = window.mealSettings; //AddIns and Diets on-off settings, assetsFaviconUrl
  const redirectEditQuantity = parsed.edit_quantity ? true : false; //Redirect from Account Settings in order to change quantity of subscription
  
  if (typeof window !== "undefined") {
    if (parsed.customer_id) {
      setCustomerId(parsed.customer_id);
    } else {
      let re = /\/(\d+)/,
        match = re.exec(window.location.href);

      if (match) {
        setCustomerId(match[1]);
      }
    }
  }

  const getTemplateType = (template) => {
    switch (template) {
      case "page.meals":
        return "meals";
      case "customers/account":
        return "account";
      case "page.menu":
        return "menu";
      default:
        return "404";
    }
  };

  const templateType = getTemplateType(templatePage);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {templateType === "meals" && typeof mealConstructorCollections !== "undefined" && (
        <MealSelector
          customerId={customerId}
          mealConstructorCollections={mealConstructorCollections}
          mode={"constructor"}
          mealSettings={mealSettings}
        />
      )}
      {templateType === "account" && (
        <CustomerPortal customerId={customerId} redirectEditQuantity={redirectEditQuantity} mealSettings={mealSettings} />
      )}
      {templateType === "menu" && (
        <MenuPage />
      )}
      {templateType === "404" && <NotFound />}
    </ThemeProvider>
  );
}
